import type { ShopperProductsTypes } from 'commerce-sdk-isomorphic';

export const getRootCategory = (
    parentCategoryTree: ShopperProductsTypes.PathRecord[] | undefined,
): ShopperProductsTypes.PathRecord[] =>
    parentCategoryTree && parentCategoryTree.length ? [parentCategoryTree[0]] : [];
